export const WELCOME= '/welcome';
export const GAMEOVERVIEW= '/game-overview';
export const WHAT_TO_EXPECT = '/what-to-expect';
export const SPECIALWELCOME = '/special-welcome';
export const LOBBY = '/lobby';
export const COURSEVIEWER_MAIN = '/course-selection';
export const COURSESELECTOR_HOST = '/host/course-selection';
export const COURSEVIEWER_LOBBY = '/lobby/course-selection';
export const HOME = '/home';
export const PROFILE_SETUP = '/profile-setup';

export const TEAMS = '/teams';
export const TEAMNAME = '/team-name';
export const JOINORHOST = '/join-or-host';

export const TIP= '/tip';
export const PAY = '/pay';
export const RULES= '/rules';
export const MAP= '/map';
export const FEEDBACK= '/feedback';

export const DELETEMYDATA = '/delete-my-data';
export const PRIVACYPOLICY = '/privacy-policy';

export const TEST = '/testing-screen';
export const TESTLANDING = '/test';
export const COURSE_CONTENT_REVIEW = '/testing-screen/course-content';
export const ToCourseContentReview = (course) => (`${COURSE_CONTENT_REVIEW}/${course}`);

export const SUMMARY= '/summary';
export const POSTGAMESURVEY= '/post-game-survey';
export const END= '/end';
export const LEADERBOARD = '/leaderboard';
export const RATEUS = '/rate-us';



export const ToEnd = (course) => (`/course/${course}${END}`);
export const ToMap = (course) => (`/course/${course}${MAP}`);
export const ToSummary = (course) => (`/course/${course}${SUMMARY}`);
export const ToQuestion = (course, currentQ) => (`/course/${course}/q/${currentQ}`);
export const ToNextQuestion = (course, currentQ) => (`/course/${course}/q/${currentQ + 1}`);
export const ToQuestionAnswer = (course, currentQ) => (`/course/${course}/q/${currentQ}/answer`);